import { StatefulTabItem } from '@shared/directives/stateful-tab/stateful-tab-item';
import { StatefulTabType } from '@shared/directives/stateful-tab/stateful-tab-type';
import { StatefulTabUtil } from '@shared/directives/stateful-tab/stateful-tab.util';
import { TaskTabActions, TaskTabActionTypes } from '@tasks-store/actions/task-tab.actions';

export type TaskTabStateMap = Map<number, TaskTabState>;

export class TaskTabState extends StatefulTabItem {
	constructor(route: string, headerText: string, sortOrder: number) {
		super(
			route,
			StatefulTabType.TASKS_TASK_TAB,
			{headerText, sortOrder},
		);
	}
}

export const initialState: TaskTabStateMap = new Map();

export function reducer(state = initialState, action: TaskTabActions): TaskTabStateMap {
	switch (action.type) {

		case TaskTabActionTypes.ADD_TASK_TAB: {
			const taskTabStateMap = new Map(state);
			if (!taskTabStateMap.get(action.payload.tabKey)) {
				const sortOrder = StatefulTabUtil.getNextSortOrder(taskTabStateMap);
				taskTabStateMap.set(action.payload.tabKey, new TaskTabState(
					action.payload.route,
					action.payload.headerText,
					sortOrder));
				return taskTabStateMap;
			} else {
				return state;
			}
		}

		case TaskTabActionTypes.REMOVE_TASK_TAB: {
			const taskTabStateMap = new Map(state);
			taskTabStateMap.delete(action.payload.tabKey);
			return taskTabStateMap;
		}

		case TaskTabActionTypes.UPDATE_TASK_TAB_HEADER_TEXT: {
			const taskTabStateMap = new Map(state);
			const taskTabState = taskTabStateMap.get(action.payload.tabKey);
			if (taskTabState) {
				taskTabStateMap.set(action.payload.tabKey, {...taskTabState, headerText: action.payload.headerText});
			}
			return taskTabStateMap;
		}

		default: {
			return state;
		}
	}
}
